export default __webpack_public_path__ + "static/media/logo.24db0d88.png";